import { a as languages } from "../../core-8vQkh0Rd.js";
import { n as extend, r as insertBefore } from "../../language-D-vtM55V.js";
import "./scheme.js";
//#region src/prism/languages/racket.js
insertBefore(languages.rkt = languages.racket = extend("scheme", { "lambda-parameter": {
	pattern: /([(\[]lambda\s+[(\[])[^()[\]'\s]+/,
	lookbehind: true
} }), "string", { "lang": {
	pattern: /^#lang.+/gm,
	alias: "keyword"
} });
//#endregion

//# sourceMappingURL=racket.js.map